import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import { onError } from 'apollo-link-error';
import { setContext } from 'apollo-link-context';
import { RetryLink } from 'apollo-link-retry';
// eslint-disable-next-line import/no-extraneous-dependencies
import fetch from 'unfetch';
import {
  serverError, l, consts, auth,
} from 'src/utils';
import { BACKEND_HTTP_PATH } from 'src/config';
import eventBus from 'src/features/eventBus';
import settings from 'src/features/settingsByApollo';

const UNAUTHORIZED = 'unauthorized';

const httpLink = new HttpLink({
  uri: `${BACKEND_HTTP_PATH}api/customers`,
  fetch,
});

function logout() {
  eventBus.$emit(consts.FORCE_LOGOUT);
}

function fibonacciDelay(attempt) {
  const fib = (n) => (n <= 1 ? n : fib(n - 1) + fib(n - 2));
  return fib(attempt) * 1000 + Math.random() * 1000; // Фибоначчи в миллисекундах + размазывание
}

const authLink = setContext((_, { headers }) => {
  const jwt = auth.getToken(settings.getCurrentToken());
  return {
    headers: {
      ...headers,
      authorization: jwt ? `Bearer ${jwt}` : '',
    },
  };
});

const errorLink = onError(({ networkError, graphQLErrors }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({
      message, locations, path, error,
    }) => {
      l.error(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`);
      if (message.indexOf(UNAUTHORIZED) > -1) {
        logout();
      } else if (error) {
        if (error.code === consts.UNAUTHORIZED) {
          logout();
        } else {
          serverError.handle(error, path[0], message);
        }
      }
    });
  }

  if (networkError && networkError.statusCode === 401) {
    l.error(`Произошел выход из системы (причина ${networkError.statusCode})`);
    logout();
  }
});

const retryLink = new RetryLink({
  delay: {
    initial: 1000 + Math.random() * 1000,
    max: Infinity,
    jitter: false,
  },
  attempts: {
    max: 5,
    delay: fibonacciDelay,
    retryIf: (error, operation) => {
      const { response } = operation.getContext();
      if (response && (response.status === 401 || response.status === 403)) {
        return false;
      }
      return !!error;
    },
  },
});

const link = ApolloLink.from([authLink, errorLink, retryLink, httpLink]);

const client = new ApolloClient({
  link,
  cache: new InMemoryCache(),
  connectToDevTools: true,
});

export default { client };
